import { Link } from "react-router-dom";
import NewsCard from "@/components/feature/NewsCard";
import {
  getExclusiveNews,
  getLatestNews,
  allTopics,
  getNewsByTopic,
  formatViews,
} from "@/utils/news";

export default function LatestNews() {
  const latest = getLatestNews(6);
  const exclusive = getExclusiveNews(4);

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-shell px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="mb-6 flex items-end justify-between">
              <div>
                <span className="font-label text-xs tracking-[0.3em] text-primary-700">
                  LATEST
                </span>
                <h2 className="mt-2 flex items-center gap-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                  <span className="h-5 w-1.5 rounded-full bg-primary-500" />
                  最新爆料
                </h2>
              </div>
            </div>

            <div className="space-y-4">
              {latest.map((item) => (
                <NewsCard key={item.id} item={item} />
              ))}
            </div>
          </div>

          <aside className="space-y-8">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center gap-2">
                <span className="flex h-6 w-6 items-center justify-center rounded-md bg-accent-500 text-background-50">
                  <i className="ri-flashlight-fill text-xs" />
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  独家爆料
                </h3>
              </div>
              <ul className="mt-4 space-y-4">
                {exclusive.map((item, order) => (
                  <li key={item.id}>
                    <Link
                      to={`/detail/${item.id}`}
                      className="group flex gap-3"
                    >
                      <span className="font-heading text-lg font-black text-background-400">
                        {String(order + 1).padStart(2, "0")}
                      </span>
                      <div>
                        <p className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-accent-400">
                          {item.title}
                        </p>
                        <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                          <i className="ri-eye-line" />
                          {formatViews(item.views)}
                        </p>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center gap-2">
                <span className="flex h-6 w-6 items-center justify-center rounded-md bg-secondary-500 text-foreground-950">
                  <i className="ri-price-tag-3-line text-xs" />
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  热门专题
                </h3>
              </div>
              <ul className="mt-4 space-y-3">
                {allTopics.map((topic) => (
                  <li key={topic.id}>
                    <Link
                      to={`/topic/${topic.id}`}
                      className="group flex items-center justify-between rounded-md bg-background-100 px-3 py-2.5 transition-colors hover:bg-background-200"
                    >
                      <span className="text-sm text-foreground-700 transition-colors group-hover:text-foreground-950">
                        {topic.name}
                      </span>
                      <span className="text-xs text-foreground-500">
                        {getNewsByTopic(topic.id).length} 篇
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}